<template>
  <div class="people-popup">
    <PopupHeader title="Liczba uczestników" icon="couple" @close="close" />
    <PeopleEdit class="people-popup__body" :value="people" />
    <PopupFooter @select="$emit('input', people)" selectAll="" @clear="clear"/>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'

import PopupFooter from './PopupFooter.vue'
import PopupHeader from './PopupHeader.vue'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import BodyFreezerMixin from '@/components/BodyFreezerMixin'
import PeopleEdit from '@/components/search/fields/PeopleEdit.vue'

@Component({
  mixins: [
    AutoCloseMixin,
    BodyFreezerMixin,
  ],
  components: {
    PopupHeader,
    PopupFooter,
    PeopleEdit,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
})
export default class People extends Vue {
  people = cloneDeep(this.value)

  created () {
    this.freezeBody()
  }
  
  destroyed () {
    this.unfreezBody()
  }

  updateChildrenBirthdays () {
    while (this.people.childrenBirthdays.length < this.people.children.value) {
      this.people.childrenBirthdays.push(moment().subtract(3, 'years'))
    }
    while (this.people.childrenBirthdays.length > this.people.children.value) {
      this.people.childrenBirthdays.pop()
    }
  }

  clear () {
    this.people.adults.value = 2
    this.people.children.value = 0
    this.people.childrenBirthdays = []
  }
}
</script>

<style lang="scss">
@import '../mobile-popup.scss';

.people-popup {
  @include mobile-popup(white, #005ca9);

  &__body {
    @include mobile-popup__body(black, white);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/PeoplePopup.vue